export enum SampleStatus {
    Functional = 1,
    NotFunctional = 2,
}
